import BlueButton from "../../common/BlueButton/BlueButton";
import CardContainer from "../../common/CardContainer";
import notificationService from "../../../services/NotificationService";
import LoadingDisplay from "../../common/LoadingDisplay/LoadingDisplay";
const ContentCard = ({
    reportedImages,
    deleteReported,
    deleteReportedImageFromSearch,
    deleteReportedImage,
    timeConverter,
}) => {
    const handleDeleteAction = (item, message, title, deleteFunction) => {
        notificationService.setMessage(message);
        notificationService.setTitle(title);
        notificationService.onClick(() => {
            // Reset the window
            notificationService.clearAll();

            // Perform the delete action
            deleteFunction(item);
        });
    };

    const deleteReportedImageFromSearchQuestion = (item) => {
        const message = `Are you sure you want to delete this image from SEARCH? ${item.templateId}`;
        const title = "Delete From Search";
        handleDeleteAction(item, message, title, deleteReportedImageFromSearch);
    };

    const deleteReportedQuestion = (item) => {
        const message = `Are you sure you want to remove the report for ${item.templateId}?`;
        const title = "Remove Reported Image";
        handleDeleteAction(item, message, title, deleteReported);
    };

    const deleteReportedImageQuestion = (item) => {
        const message = `Are you sure you want to delete this image COMPLETELY? ${item.templateId}`;
        const title = "Delete Completely";
        handleDeleteAction(item, message, title, deleteReportedImage);
    };

    //loop through each elemnt
    let arr = [];

    if (reportedImages.length) {
        reportedImages.forEach((item, i) => {
            let reporterList = item.reporters.replace(/[^0-9\n]/g, "");

            let buttons =
                item.imageRemoved === "true" ? (
                    <p>{item.message ? item.message : "Deletion Pending!"}</p>
                ) : (
                    <>
                        <p>{item.message ? item.message : "Select options"}</p>
                        <BlueButton
                            isCenter={true}
                            text="Remove from search"
                            onClick={() =>
                                deleteReportedImageFromSearchQuestion(item)
                            }
                            isLarge={true}
                        />
                        <br />
                        <br />
                        <BlueButton
                            isCenter={true}
                            text="Remove completly"
                            onClick={() => deleteReportedImageQuestion(item)}
                            isLarge={true}
                        />
                    </>
                );

            let contentLeft = (
                <>
                    <p>
                        Report reason : {item.reason ? item.reason : "NO INFO"}
                    </p>
                    <p>Report count : {item.count ? item.count : "NO INFO"}</p>
                    <p>
                        Image creator :{" "}
                        {item.creator ? item.creator : "NO INFO"}
                    </p>
                    <p>
                        Last reported :{" "}
                        {item.time ? timeConverter(item.time) : "NO INFO"}
                    </p>
                    <p>
                        Searchable :{" "}
                        {item.searchable ? item.searchable : "NO INFO"}
                    </p>
                    <p>
                        Completly Deleted :{" "}
                        {item.imageRemoved ? item.imageRemoved : "NO INFO"}
                    </p>
                    <p>Reported by : {JSON.stringify(reporterList)}</p>
                </>
            );

            let contentRight = <> {buttons}</>;
            if (item.isLoading)
                contentRight = (
                    <LoadingDisplay invert={true} globalDivOff={true} />
                );

            let content = (
                <CardContainer
                    item={item}
                    removeItem={() => deleteReportedQuestion(item)}
                    isButtonGray={item.isLoading}
                    contentRight={contentRight}
                    contentLeft={contentLeft}
                    reportCount={item.count ? item.count : 0}
                />
            );

            arr.push(<div key={i}>{content}</div>);
        });
    }
    return <>{arr}</>;
};

export default ContentCard;
